import { useCallback, useState } from 'react';

/**
 * Kopiert einen Text und meldet kurz „kopiert“ — oder „ging nicht“, wenn der Browser die
 * Zwischenablage verweigert (In-App-Browser, fehlende Berechtigung). Ohne diese Meldung tat ein
 * reiner Symbolknopf dort einfach nichts.
 */
export function useCopyToClipboard(
  resetMs = 1500,
): [boolean, (value: string) => Promise<void>, boolean] {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);
  const copy = useCallback(
    async (value: string) => {
      try {
        await navigator.clipboard.writeText(value);
        setFailed(false);
        setCopied(true);
        window.setTimeout(() => setCopied(false), resetMs);
      } catch {
        setCopied(false);
        setFailed(true);
        window.setTimeout(() => setFailed(false), resetMs * 2);
      }
    },
    [resetMs],
  );
  return [copied, copy, failed];
}
